export default __webpack_public_path__ + "static/media/0xba25b552c8a098afdf276324c32c71fe28e0ad40.b99f0ce2.webp";